/**
 * Music Scene
 *
 * Streaming links and music videos.
 * The simplest pathway — fans already know the music.
 */

import type { Scene } from '@/types/scene';
// Custom player shelved — see music.shelved.ts

export const music: Scene = {
  id: 'music',
  name: 'Music',
  atmosphere: {
    background: 'linear-gradient(180deg, #0a0a0f 0%, #1a0a1e 100%)',
    fogIntensity: 0.3,
    noiseHue: 280,
    noiseBrightness: 0.6,
    noiseOpacity: 0.45,
  },
  interactions: [
    {
      id: 'back-home',
      target: '[data-interaction="back-home"]',
      action: { type: 'navigate', sceneId: 'home' },
    },
    {
      id: 'nav-music',
      target: '[data-interaction="nav-music"]',
      action: { type: 'navigate', sceneId: 'music' },
    },
    {
      id: 'nav-drip',
      target: '[data-interaction="nav-drip"]',
      action: { type: 'navigate', sceneId: 'drip' },
    },
    {
      id: 'nav-more',
      target: '[data-interaction="nav-more"]',
      action: { type: 'navigate', sceneId: 'more' },
    },
  ],
  transitions: [
    { to: 'home', effect: 'fade', duration: 800 },
    { to: 'music', effect: 'fade', duration: 800 },
    { to: 'drip', effect: 'fade', duration: 800 },
    { to: 'more', effect: 'fade', duration: 800 },
  ],
  render: () => `
    <div class="pathway-content">
      <iframe
        data-testid="embed-iframe"
        style="border-radius:12px"
        src="https://open.spotify.com/embed/track/73LlNo6OEa1dhorMSre7mN?utm_source=generator"
        width="50%"
        height="352"
        frameBorder="0"
        allowfullscreen
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      ></iframe>
    </div>
  `,
};
